module.exports = __webpack_public_path__ + "img/calligraphy-work-icon2.67e5c349.jpg";